export const useSmoothScrolling = (value: boolean): void => {
  const isEnabled = computed(() => value)

  useHead(
    {
      htmlAttrs: {
        tagDuplicateStrategy: 'replace',
        class: { 'smooth-scrolling': isEnabled },
      },
    },
    { mode: 'client' },
  )
}
